import { BaseEntity } from '../../../base/BaseEntity';
import { Time } from '@angular/common';
import { ItemType } from './item-type';

export class Item  extends BaseEntity {
    idState:string;
    idItemType:string;
    idAccount:string;
    idLocation:string;
    idUser:string;
    from:Date;
    till:Date;
    duration:Time;
    active?:Boolean;
    isManul?:Boolean;
    type?:ItemType;
}
